import React, { FC } from 'react';

import styles from './HowItWorks.module.css';
import { Page } from '../../../state/types';
import { config } from '../../../state/config';
import { useState } from '../../../state/store';

const HowItWorks: FC = () => {
  const { page } = useState('page');

  if (page !== Page.HowItWorks) {
    return null;
  }

  return (
    <div className={`${styles.HowItWorks} container flex flex-col text-center`} data-testid="HowItWorksPage">
      <section>
        <div>
          <h2>HOW IT WORKS</h2>
        </div>
        <div className="card info-block">
          <div className="card-body">
            <p>
              On receiving your new Galaxy Flip/Fold device simply follow the steps below. Each step will clearly
              outline what you need to do and the value you can redeem against the smartphone device you are trading in.
            </p>
          </div>
        </div>
        <div className="row steps-block">
          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <img src={`${config.publicUrl}/img/steps/Step1.png`} alt="Step 1" />
                <h4>STEP 1</h4>
                <p>
                  Purchase any new Galaxy Flip/Fold device either in store or online from one of the participating
                  retailers.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <img src={`${config.publicUrl}/img/steps/Step2.png`} alt="Step 2" />
                <h4>STEP 2</h4>
                <p>
                  On receipt of your new Galaxy Flip/Fold device, please <a href={`#${Page.Home}`}>click here</a> to
                  start the trade-in process.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <img src={`${config.publicUrl}/img/steps/Step3.png`} alt="Step 3" />
                <h4>STEP 3</h4>
                <p>
                  Complete the <a href={`#${Page.Home}`}>trade-in</a> process and submit your claim.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <img src={`${config.publicUrl}/img/steps/Step4.png`} alt="Step 4" />
                <h4>STEP 4</h4>
                <p>Return your device and redeem your trade-in value.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="card info-block">
          <div className="card-body">
            <p className="lead">We will take Any smartphone in Any condition*</p>
            <p>&nbsp;</p>
            <p className="fst-italic">
              * Trade in values will vary based on smartphone condition. Must be a Smartphone. Promotion T&C’s Apply.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className="row trade-in-requirements align-items-center">
          <div className="col-lg-6 col-sm-12">
            <img src={`${config.publicUrl}/img/phones/galaxy_flip.jpg`} alt="Working Phone" />
          </div>
          <div className="col-lg-6 col-sm-12 criteria-block">
            <p className="lead text-center">Smartphone Good Working Condition</p>
            <ul>
              <li>It must power on/up and hold a charge.</li>
              <li>It must be fully functional and must have no software or hardware faults.</li>
              <li>
                It must only have normal wear and tear - there must be no damage or blemishes to screen/LCD and the
                casing around the device including the camera lens must not be cracked. No level of liquid damage is
                acceptable.
              </li>
              <li>
                It must have a fully functioning display and have no cracked screen, blobs, heavy screen burn, pink hue
                or pressure marks.
              </li>
              <li>It must not be blacklisted - each device must be eligible to pass all lost/stolen registers.</li>
              <li>
                It must be factory reset and have no software locks - the device must have any personal account locks
                removed and the device must be reset to remove personal data, all devices must have their iCloud or
                Google accounts removed or custom MDM/UEM accounts removed.
              </li>
              <li>It must not be PIN locked and must not have an ‘Activation Lock’ or 'iCloud Lock' activated.</li>
              <li>It must include its battery within the casing and must not have any missing parts.</li>
              <li>It must not be crushed, bent in half or liquid-damaged.</li>
              <li>
                It must not be “jail-broken, “rooted”, “bricked” or “Knox warranty void” and the firmware must not have
                been altered.
              </li>
              <li>
                It must be original and meet the manufacturer’s original EU specifications (and is not personalised with
                any custom engraving).
              </li>
              <li>Not have any other issues which affect our ability to resell it.</li>
            </ul>
            <p className="text-center">Please ensure All memory cards, sim cards are removed before shipping to us.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowItWorks;
